// Worker types
export const WORKER_FETCH_REQUEST = "WORKER_FETCH_REQUEST";
export const WORKER_FETCH_SUCCESS = "WORKER_FETCH_SUCCESS";
export const WORKER_FETCH_FAILURE = "WORKER_FETCH_FAILURE";
export const WORKER_DETAIL = "WORKER_DETAIL";

// Attendance types
export const ATTENDANCE_FETCH_REQUEST = "ATTENDANCE_FETCH_REQUEST";
export const ATTENDANCE_FETCH_SUCCESS = "ATTENDANCE_FETCH_SUCCESS";
export const ATTENDANCE_FETCH_FAILURE = "ATTENDANCE_FETCH_FAILURE";

// Advance types
export const ADVANCE_FETCH_REQUEST = "ADVANCE_FETCH_REQUEST";
export const ADVANCE_FETCH_SUCCESS = "ADVANCE_FETCH_SUCCESS";
export const ADVANCE_FETCH_FAILURE = "ADVANCE_FETCH_FAILURE";

// Salary types
export const SALARY_FETCH_REQUEST = "SALARY_FETCH_REQUEST";
export const SALARY_FETCH_SUCCESS = "SALARY_FETCH_SUCCESS";
export const SALARY_FETCH_FAILURE = "SALARY_FETCH_FAILURE";
